<template>
    <div class="container-fluid">
        <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
        <div class="row">
            <div class="col-md-12">
                <h3>
                    User Teams
                    <button @click="$refs.newTeam.show()" class="btn btn-success btn-sm float-right"> <icon name="plus-square"></icon> Create Team</button>
                </h3>

                <p>This section displays the list of existing teams.
                    Please click on the team name to see the list of associated users</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3"
                 style="min-width: 360px;
                 border-right: solid 1px #e7e7e7;
                 overflow-y: auto;
                 overflow-x: hidden;
                 max-height: 67vh;
                 border-top: solid 1px #e7e7e7;"
            >
                <div style="border-bottom: solid 1px #e6e6e6; padding: 15px;">
                    <strong>Teams List</strong><span class="float-right">Manager</span>
                </div>

                <div class="row prehighlight" style="border-bottom: solid 1px #e6e6e6;"
                     :class="{highlighted: selectedTeam == team.id}"
                     v-for="team in teams"
                     @click="selectTeam(team.id)"
                >
                    <div class="col">
                        <h6><icon name="users"></icon> {{team.name}} <span class="float-right"><b-badge variant="info">{{managedBy(team.id)}}</b-badge></span> </h6>
                        <span v-for="category in team.categories">
                        <b-badge variant="light">{{category.name}}</b-badge>
                        </span>
                    </div>

                </div>
            </div>
            <div class="col listxxx" style="overflow-y: auto; height: 67vh;  overflow-x: hidden;  border-top: solid 1px #e7e7e7;">
                <div style="border-bottom: solid 1px #e6e6e6; padding: 15px; width: 100%;">
                    <strong class="float-left">{{selectedTeamName}}:</strong>&nbsp; List of Associated Users.
                    <button @click="deleteTeam(selectedTeam)" class="btn btn-danger btn-sm float-right" style="margin-left: 10px;"><icon name="trash" scale="1.1"></icon> Delete</button>
                    <button @click="$refs.updateTeam.show()" class="btn btn-info btn-sm float-right"><icon name="pencil" scale="1.1"></icon>&nbsp; Update Team</button>
                </div>

                <transition name="slide" mode="out-in">
                    <div :key="selectedTeam">
                        <div class="row prehighlight" v-for="user in users" style="border-bottom: solid 1px #f0f0f0;">
                            <div class="col-md-2">
                                <toggle-button :value="checkTeamSubscriptionStatus(selectedTeam, user.teams)"
                                               @change="toggleTeam(selectedTeam, user.id)"
                                               color="#82C7EB"
                                               :sync="true"
                                               :labels="{checked: 'Yes', unchecked: 'No'}">
                                </toggle-button>
                            </div>
                            <div class="col-md-10">
                                <h6>
                                    {{user.name}}
                                    <span v-if="user.active === 1 && user.confirmed === 1" class="float-right"><b-badge variant="success">ACTIVE</b-badge> &nbsp; </span>
                                    <span v-if="user.active === 0" class="float-right"><b-badge variant="danger">INACTIVE</b-badge> &nbsp; </span>
                                    <span v-if="user.confirmed === 0" class="float-right"><b-badge variant="warning">Unconfirmed</b-badge> &nbsp; </span>
                                    <span v-if="user.admin === 1" class="float-right"><b-badge variant="primary">Super Admin</b-badge> &nbsp; </span>
                                </h6>

                            </div>

                        </div>
                    </div>
                </transition>

            </div>
        </div>

        <b-modal ref="newTeam" size="lg" centered >
            <div slot="modal-header">
                <h3>Create a New Team</h3>
            </div>

            <b-container fluid>
                <p>Please use the form below to create a new team.</p>
                <form @submit.prevent="onSubmit"
                      @keydown="form.errors.clear($event.target.name)"
                      @change="form.errors.clear($event.target.name)"
                      @click.right="form.errors.clear($event.target.name)"
                >

                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">Name:</label>
                        <div class="col-sm-9">
                            <input type="text" v-model="form.name" class="form-control" :class="{'is-danger-input': form.errors.has('name')}" title="name">
                            <span class="help is-danger" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">Team Manager:</label>
                        <div class="col-sm-9">
                            <select :class="{'is-danger-input': form.errors.has('managerID')}" class="form-control" v-model="form.managerID">
                                <option v-for="user in users" v-bind:value="user.id">
                                    {{user.name}}
                                </option>
                            </select>
                            <span class="help is-danger" v-if="form.errors.has('managerID')" v-text="form.errors.get('managerID')"></span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">Team Categories:</label>
                        <div class="col-sm-9">
                            <div class="row" v-for="category in teamCategory">
                                <div class="col-md-2">
                                    <toggle-button @change="toggleCategories(category.id)"
                                                   color="#82C7EB"
                                                   :sync="true"
                                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                                    </toggle-button>
                                </div>
                                <div class="col-md-10">
                                    {{category.name}}
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
                <b-alert v-if="form.errors.error.title || form.errors.error.message" show variant="warning">
                    <span class="help is-danger">
                        <icon name="warning" scale="0.9"></icon> &nbsp;
                        <strong v-if="form.errors.error.title">{{form.errors.error.title}}: <br/></strong>
                        {{form.errors.error.message}}
                    </span>
                </b-alert>
            </b-container>

            <div slot="modal-footer">
                <button :disabled="form.errors.any() || form.isDisabled" class="btn btn-success float-right" @click="saveTeam()"><icon name="save"></icon> Save Team</button>
                <button class="btn btn-dark float-right" style="margin-right: 5px;" @click="$refs.newTeam.hide()"><icon name="times"></icon> Cancel</button>
            </div>
        </b-modal>

        <b-modal ref="updateTeam" size="lg" centered >
            <div slot="modal-header">
                <h3>Update Team</h3>
            </div>

            <b-container fluid>
                <p>Please use the form below to update the team.</p>
                <form @submit.prevent="onSubmit"
                      @keydown="form2.errors.clear($event.target.name)"
                      @change="form2.errors.clear($event.target.name)"
                      @click.right="form2.errors.clear($event.target.name)"
                >

                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">Name:</label>
                        <div class="col-sm-9">
                            <input type="text" v-model="form2.name" class="form-control" :class="{'is-danger-input': form2.errors.has('name')}" title="name">
                            <span class="help is-danger" v-if="form2.errors.has('name')" v-text="form2.errors.get('name')"></span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">Team Manager:</label>
                        <div class="col-sm-9">
                            <select :class="{'is-danger-input': form2.errors.has('managerID')}" class="form-control" v-model="form2.managerID">
                                <option v-for="user in users" v-bind:value="user.id">
                                    {{user.name}}
                                </option>
                            </select>
                            <span class="help is-danger" v-if="form2.errors.has('managerID')" v-text="form2.errors.get('managerID')"></span>
                        </div>
                    </div>

                    <div v-if="selectedTeamObject && selectedTeamObject.system != 1" class="form-group row">
                        <label class="col-sm-3 col-form-label">Team Categories:</label>
                        <div class="col-sm-9">
                            <div class="row" v-for="category in teamCategory">
                                <div class="col-md-2">
                                    <toggle-button :value="checkTeamCategories(category.id, selectedTeam)"
                                                   @change="toggleUpdateCategories(category.id)"
                                                   color="#82C7EB"
                                                   :sync="true"
                                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                                    </toggle-button>
                                </div>
                                <div class="col-md-10">
                                    {{category.name}}
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
                <b-alert v-if="form2.errors.error.title || form2.errors.error.message" show variant="warning">
                    <span class="help is-danger">
                        <icon name="warning" scale="0.9"></icon> &nbsp;
                        <strong v-if="form2.errors.error.title">{{form2.errors.error.title}}: <br/></strong>
                        {{form2.errors.error.message}}
                    </span>
                </b-alert>
            </b-container>

            <div slot="modal-footer">
                <button :disabled="form2.errors.any() || form2.isDisabled" class="btn btn-success float-right" @click="updateTeam()"><icon name="save"></icon> Update Team</button>
                <button class="btn btn-dark float-right" style="margin-right: 5px;" @click="$refs.updateTeam.hide()"><icon name="times"></icon> Cancel</button>
            </div>
        </b-modal>


    </div>
</template>

<script>
  import {Form, Errors} from '@/components/validations/forms';
  import {mixin} from '@/mixins/mixins';
  export default {
    mixins: [mixin],
    data () {
      return {
        breadcrumbs: [
          {text: 'Home', to: '/dashboard'},
          {text: 'Settings', to: '/settings'},
          {text: 'Manage Teams', active: true},
        ],
        users: [],
        teams: [],
        teamCategory: [],
        form: new Form({
          name: null,
          managerID: null,
          categories: [],
          isDisabled: false,
        }),

        form2: new Form({
          teamID: null,
          name: null,
          managerID: null,
          categories: [],
          isDisabled: false,
        }),

        form3: new Form({
          teamID: this.selectedTeam
        }),

        toggleTeamsData: {
          teamID: null,
          userID: null,
        },
        selectedTeam: null,
      }
    },

    methods: {
      selectTeam(teamID){
        this.selectedTeam = teamID;
        this.form2.categories = [];
        this.prepareUpdateTeamForm(teamID);
        document.getElementsByClassName('listxxx')[0].scrollTop = 0;
      },

      prepareUpdateTeamForm(teamID){
        let needle = this.teams.filter(function (el) {return el.id === parseInt(teamID);})
        let teamCategories = needle[0].categories;
        if(teamCategories.length > 0){
          for (let i = 0; i < teamCategories.length; i++) {this.form2.categories.push(teamCategories[i].id);}
        }
        this.form2.teamID = teamID;
        this.form2.name = needle[0].name;
        this.form2.managerID = needle[0].managerID;
      },

      checkTeamSubscriptionStatus(teamID, userTeams){
        let needle = userTeams.filter(function (el) {
          return el.id === parseInt(teamID)
            ;})
        if(needle.length > 0){return true;} else {return false;}
      },

      checkTeamCategories(categoryID, teamID){
        let needle = this.teams.filter(function (el) {return el.id === parseInt(teamID);})
        let teamCategories = needle[0].categories
        let needle2 = teamCategories.filter(function (el) {return el.id === parseInt(categoryID);})
        if(needle2.length > 0){return true;} else {return false;}
      },

      toggleTeam(teamID, userID)
      {
        this.$store.dispatch('teams/toggleTeamUser', {
          teamID: teamID,
          userID: userID
        })
          .then(response => {
            this.$store.dispatch('user/fetchUsers').then(response => {
              this.users = this.$store.getters['user/getUsers']
            })
          })
      },

      toggleCategories(categoryID){
        if(this.form.categories.indexOf(categoryID) > -1){
          // Remove the value
          let index = this.form.categories.indexOf(categoryID);
          this.form.categories.splice(index, 1);
        } else{
          // Add the value
          this.form.categories.push(categoryID);
        }
      },

      toggleUpdateCategories(categoryID){
        if(this.form2.categories.indexOf(categoryID) > -1){
          // Remove the value
          let index = this.form2.categories.indexOf(categoryID);
          this.form2.categories.splice(index, 1);
        } else{
          // Add the value
          this.form2.categories.push(categoryID);
        }
      },

      saveTeam () {
        this.form.isDisabled = true;
        this.$store.dispatch('teams/saveTeam', this.form)
          .then(response => {
            this.form.onSuccess(response);
            this.$snotify.success('Team has been saved successfully', '');
            this.$store.dispatch('teams/fetchTeams').then(response => {
              this.teams = this.$store.getters['teams/getTeams']
              this.$refs.newTeam.hide();
              this.form.isDisabled = false;
              this.selectTeam(this.teams[this.teams.length-1].id)
            })
          })
          .catch(error => {
            this.form.onFail(error);
            this.form.isDisabled = false;
          })
      },

      updateTeam () {
        this.form2.isDisabled = true;
        this.$store.dispatch('teams/updateTeam', this.form2)
          .then(response => {
            this.form2.onSuccess(response);
            this.$snotify.success('Team has been saved successfully', '');
            this.$store.dispatch('teams/fetchTeams').then(response => {
              this.teams = this.$store.getters['teams/getTeams']
              this.$refs.updateTeam.hide();
              this.form2.isDisabled = false;
              this.selectTeam(this.selectedTeam)
            })
          })
          .catch(error => {
            this.form2.onFail(error);
            this.form2.isDisabled = false;
          })
      },

      deleteTeam(teamID){
        this.$store.dispatch('teams/deleteTeam', teamID)
          .then(response => {
            this.form3.onSuccess(response);
            this.$snotify.success('Team has been deleted successfully', '');
            this.$store.dispatch('teams/fetchTeams').then(response => {
              this.teams = this.$store.getters['teams/getTeams']
              this.selectTeam(this.selectedTeamObject.id)
            })
          })
          .catch(error => {
            this.form3.onFail(error);
            this.$snotify.error(this.form3.errors.error.message, this.form3.errors.error.title);
          })
      },

      managedBy(teamID) {
        let users = this.users
        let teams = this.teams
        let team = teams.filter(function (el) {return el.id === parseInt(teamID);})
        let needle = users.filter(function (el) {return el.id === parseInt(team[0].managerID);})
        if(needle.length > 0){return needle[0].name;} else {return null;}
      },
    },

    computed: {
      selectedTeamName() {
        let needleTeam = this.selectedTeam
        let needle = this.teams.filter(function (el) {return el.id === parseInt(needleTeam);})
        if(needle.length > 0){return needle[0].name;} else {return null;}
      },
      selectedTeamObject() {
        let needleTeam = this.selectedTeam
        let needle = this.teams.filter(function (el) {return el.id === parseInt(needleTeam);})
        if(needle.length > 0){return needle[0];} else {return this.$store.getters['teams/getTeams'][0];}
      },
    },

    created () {
      this.$store.dispatch('user/fetchUsers') .then(response => {this.users = this.$store.getters['user/getUsers']})
      this.$store.dispatch('teams/fetchTeams') .then(response => {
        this.teams = this.$store.getters['teams/getTeams']
        this.selectTeam(this.$store.getters['teams/getTeams'][0].id)
      })
      this.$store.dispatch('teams/fetchTeamCategory') .then(response => {this.teamCategory = this.$store.getters['teams/getTeamCategory']})
      this.$store.dispatch('user/getUserProfile')
        .then(response => {this.form.managerID = this.$store.getters['user/getProfile'].id;})
    }

  }
</script>

<style>


</style>


// WEBPACK FOOTER //
// src/components/settings/users/teams.vue